import React from 'react';
import Layout from '../../components/Layout';
import PaymentError from './PaymentError';

const title = 'Payment Error';

export default async function action({ store, query }) {
  const { errorMessage } = query || {};
  
  return {
    title,
    component: <Layout><PaymentError title={title} errorMessage={errorMessage} /></Layout>,
  };
};